import { AppConfig } from '../core/api/whitelabel/whitelabel.types';

export const checkCountryCode = (
  appConfigData: AppConfig,
  requiredCountry: string,
): boolean => {
  const { CountryCode } = appConfigData;
  const isRequiredCountry = CountryCode === requiredCountry;
  return isRequiredCountry;
};
